import { Checkbox } from "../shadcn/checkbox";

type Props = {
  checked: boolean | "indeterminate";
  onCheckedChange: (checked: boolean | "indeterminate") => void;
  className?: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const StyledCheckbox = ({
  checked,
  disabled,
  onCheckedChange,
  className,
  onClick,
}: Props) => {
  const indeterminate = checked === "indeterminate";

  return (
    <Checkbox
      checked={checked}
      onCheckedChange={onCheckedChange}
      onClick={onClick}
      className={
        `relative text-[transparent] ${
          indeterminate
            ? "bg-[#0C2856]"
            : checked
            ? "bg-[#0C2856]"
            : "bg-[#D1D5DC]"
        } ${className} ` +
        (indeterminate
          ? " data-[state=indeterminate]:border-[#0C2856] data-[state=indeterminate]:bg-[#0C2856] data-[state=indeterminate]:text-transparent data-[state=indeterminate]:[&_svg]:hidden before:content-[''] before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:block before:h-[2px] before:w-3 before:rounded-full before:bg-white"
          : "")
      }
      disabled={disabled}
    />
  );
};
export default StyledCheckbox;
